import { axios } from '@Root/API'

export const getRawSubmissionData = id => {
  return axios.get(`cognito-submissions/${id}`)
}
